/**
 * Language Configuration
 *
 * Single Source of Truth for supported languages across all apps.
 * - TypeScript apps: import from this module
 * - Python apps: read languages.json directly (kept in sync manually)
 */

/**
 * 지원 언어 목록 (10개)
 * ko, en, ja, zh, ar, es, fr, hi, id, pt
 */
export const SUPPORTED_LANGUAGES = ['ko', 'en', 'ja', 'zh', 'ar', 'es', 'fr', 'hi', 'id', 'pt'] as const;

/**
 * 지원 언어 타입
 */
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

/**
 * 기본 언어
 */
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

/**
 * RTL (Right-to-Left) 언어 목록
 */
export const RTL_LANGUAGES: readonly SupportedLanguage[] = ['ar'];

/**
 * 번역 대상 언어 목록 (영어 제외, 9개)
 * ko, ja, zh, ar, es, fr, hi, id, pt
 */
export const TRANSLATION_TARGETS = ['ko', 'ja', 'zh', 'ar', 'es', 'fr', 'hi', 'id', 'pt'] as const;

/**
 * 번역 대상 언어 타입
 */
export type TranslationTargetLanguage = (typeof TRANSLATION_TARGETS)[number];

/**
 * 언어가 RTL인지 확인
 */
export function isRTL(language: string): boolean {
  return RTL_LANGUAGES.includes(language as SupportedLanguage);
}

/**
 * 유효한 지원 언어인지 확인
 */
export function isSupportedLanguage(language: string): language is SupportedLanguage {
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(language);
}

/**
 * 유효한 번역 대상 언어인지 확인
 */
export function isTranslationTarget(language: string): language is TranslationTargetLanguage {
  return (TRANSLATION_TARGETS as readonly string[]).includes(language);
}
